export function ProcessingIcon({ color = "#0A4D6E", size = 36 }: { color?: string; size?: number }) {
    return (
        <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask
                id="processing-icon-mask"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="36"
                height="36"
                {...{ masktype: "alpha" } as any}
            >
                <rect width="36" height="36" fill="#D9D9D9" />
            </mask>
            <g mask="url(#processing-icon-mask)">
                <path d="M22.5 31.5V27H16.5V12H13.5V16.5H3V4.5H13.5V9H22.5V4.5H33V16.5H22.5V12H19.5V24H22.5V19.5H33V31.5H22.5ZM25.5 13.5H30V7.5H25.5V13.5ZM25.5 28.5H30V22.5H25.5V28.5ZM6 13.5H10.5V7.5H6V13.5Z" fill={color} />
            </g>
        </svg>
    )
}

export function PackagingIcon({ color = "#0A4D6E", size = 36 }: { color?: string; size?: number }) {
    return (
        <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask
                id="packaging-icon-mask"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="36"
                height="36"
                {...{ masktype: "alpha" } as any}
            >
                <rect width="36" height="36" fill="#D9D9D9" />
            </mask>
            <g mask="url(#packaging-icon-mask)">
                <path d="M16.5 29.1375V18.8625L7.5 13.65V23.925L16.5 29.1375ZM19.5 29.1375L28.5 23.925V13.65L19.5 18.8625V29.1375ZM18 16.275L26.8875 11.1375L18 6L9.1125 11.1375L18 16.275ZM6 26.55C5.525 26.275 5.15625 25.9125 4.89375 25.4625C4.63125 25.0125 4.5 24.5125 4.5 23.9625V12.0375C4.5 11.4875 4.63125 10.9875 4.89375 10.5375C5.15625 10.0875 5.525 9.725 6 9.45L16.5 3.4125C16.975 3.1375 17.475 3 18 3C18.525 3 19.025 3.1375 19.5 3.4125L30 9.45C30.475 9.725 30.8438 10.0875 31.1063 10.5375C31.3688 10.9875 31.5 11.4875 31.5 12.0375V23.9625C31.5 24.5125 31.3688 25.0125 31.1063 25.4625C30.8438 25.9125 30.475 26.275 30 26.55L19.5 32.5875C19.025 32.8625 18.525 33 18 33C17.475 33 16.975 32.8625 16.5 32.5875L6 26.55Z" fill={color} />
            </g>
        </svg>
    )
}
